
import XDialog from 'vux/src/components/x-dialog/index.vue'

import validator from '../../../tools/validator'
import SystemApi from '../../../api/system'
import Icon from '../../../icons'
export default{
name: 'dynamicCodeView',
components: {
XDialog,
Icon
},
data() {
return {
imageUrl: '',
dynamicCode: '',
showNotice: false,
noticeText: '',
needRealTimeCheck: false,
sureButtonEnabled: false,
maskTransition: 'vux-mask',
dialogTransition: 'vux-dialog',
show: false
}
},
methods: {
switchDynamicCode() {
SystemApi.preSwitchDynamicCode().then(() => {
this.imageUrl = process.env.BASE_URL + 'user/imageCode?r=' + Math.random() * 9999;
}).catch(() => {
});
},
validateCode() {
this.needRealTimeCheck = true;
if (validator.checkEmpty(this.dynamicCode)) {
this.showNotice = true;
this.noticeText = '请输入验证码';
} else if (this.dynamicCode.length !== 4) {
this.showNotice = true;
this.noticeText = '验证码格式不正确';
} else {
this.sureButtonEnabled = false;
SystemApi.validateDynamicCode({
imageCode: this.dynamicCode
}).then(() => {
this.hideSelf();
this.realTimeCheckButtonEnable();
}).catch((error) => {
this.showNotice = true;
this.noticeText = error.errMsg;
this.realTimeCheckButtonEnable();
});
}
},
hookInputChanged() {
this.realTimeCheckButtonEnable();
if (this.needRealTimeCheck) {
if (validator.checkEmpty(this.dynamicCode)) {
this.showNotice = false;
} else {
this.showNotice = this.dynamicCode.length !== 4;
if (this.showNotice) {
this.noticeText = '验证码格式不正确';
}
}
}
},
realTimeCheckButtonEnable() {
this.sureButtonEnabled = !validator.checkEmpty(this.dynamicCode);
},
hideSelf() {
this.$emit('onValidateSuccess')
this.show = false;
},
closeSelf() {
this.show = false;
}
},
mounted() {
this.$watch('dynamicCode', function (newVal, oldVal) {
this.hookInputChanged();
});
this.$watch('show', function (newVal, oldVal) {
if (newVal === true) {
this.dynamicCode = '';
this.needRealTimeCheck = false;
this.showNotice = false;
this.switchDynamicCode();
}
});
}
}



// WEBPACK FOOTER //
// ./src/components/views/common/xy-dynamicVerifyCode-view.vue